/* eslint-disable max-statements */
/* eslint-disable max-params */
/* eslint-disable new-cap */
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';
import {noTimeZoneShortISODate} from '../../common/constants/datesFormat';
import moment from 'moment';
import {TOYOTA_RUC} from '../../common/constants/dealer';

const removeDuplicates = (arr, key) => {
  return Array.from(new Set(arr.map((a) => a[key]))).map((id) => {
    return arr.find((a) => a[key] === id);
  });
};

export const mapListToDropdownList = (
  list,
  {keys, values, texts},
  allOption = false,
  separator = '-'
) => {
  if (list) {
    const listDropdown = [
      {
        'key': '',
        'value': '',
        'text': 'TODOS',
      },
    ];

    const listData = list.map((item) => {
      const itemKey = keys.map((key) => item[key]).join(separator);
      const itemValues = values.map((key) => item[key]).join(separator);
      const itemTexts = texts.map((key) => item[key]).join(separator);
      return {
        'key': itemKey,
        'value': itemValues,
        'text': itemTexts || '(Sin nombre)',
      };
    });
    const listWithoutDuplicates = removeDuplicates(listData, 'key');

    if (allOption) {
      return listDropdown.concat(listWithoutDuplicates);
    }
    return listWithoutDuplicates;
  }
  return [];
};

const dataToExport = (allData, {isUserTde, dealerId}) => {
  return allData.map((data) => {
    const dollarUS = Intl.NumberFormat('de-DE');
    const allowedField = isUserTde || data.dealerReservation === dealerId;
    return {
      'depositNumber': data?.daysInDeposit?.split('/')[0] || '',
      'floatingStateText': data?.floatingStateText,
      'solNacNumber': data?.solNacNumber,
      'chassis': data?.chassis,
      'orderNumber': data?.orderNumber,
      'line': data?.line,
      'sfx': data?.sfx,
      'dealerName': data?.dealerName,
      'description': data?.description,
      'clientId': allowedField ? data?.document : '',
      'clientName': allowedField ? `${data?.lastNames || ''} ${data?.names || ''}` : '',
      'adviser': data?.adviserName,
      'arrivalDate': data?.arrivalDate?.substring(0, 10),
      'fobValue': data?.fobValue ? `$ ${dollarUS.format(data?.fobValue)}` : '',
      'externalColor': data?.externalColor,
      'externalColorId': data?.externalColorId,
      'internalColor': data?.internalColor,
      'internalColorId': data?.internalColorId,
      'motor': data?.motor,
      'yearModel': data?.yearModel,
      'locationText': data?.locationText,
      'depositDate': data?.depositDate?.substring(0, 10),
      'importer': data?.importerName,
      'exonerationPerc': allowedField ? data?.exonerationPerc : '',
      'businessType': data?.clientTypeText,
      'reserveAdvance': data?.reserveAdvanceText,
      'observations': data?.observations,
      'reservationDays': data?.reservationDays,
      'reservationFloatingDate': data?.reservationFloatingDate?.substring(0, 10),
      'solNacDate': data?.solNacDate?.substring(0, 10),
      'informBillDate': data?.informBillDate ? moment(data?.informBillDate, noTimeZoneShortISODate)
        .format(noTimeZoneShortISODate) : '',
      'billEstDate': data?.estSaleDate ? moment(data?.estSaleDate, noTimeZoneShortISODate)
        .format(noTimeZoneShortISODate) : '',
      'destinyText': data?.destinyText,
    };
  });
};

const headerFlInventoryData = [
  'DÍAS EN DEPÓSITO',
  'ESTADO',
  'SOLICITUD NACIONALIZACIÓN',
  'CHASIS',
  'PEDIDO',
  'LÍNEA',
  'SFX',
  'DEALER',
  'DESCRIPCIÓN',
  'CÉDULA CLIENTE',
  'NOMBRE CLIENTE',
  'ASESOR',
  'FECHA DE LLEGADA',
  'VALOR FOB',
  'COLOR EXTERNO',
  'CÓDIGO EXTERNO',
  'COLOR INTERNO',
  'CÓDIGO INTERNO',
  'MOTOR',
  'AÑO MODELO',
  'UBICACIÓN',
  'FECHA DEPÓSITO',
  'IMPORTADOR',
  '% EXONERACIÓN%',
  'TIPO DE NEGOCIO',
  'AVANCE RESERVA',
  'OBSERVACIONES',
  'DÍAS RESERVA',
  'FECHA RESERVA',
  'FECHA SOL. NACIONALIZACIÓN',
  'FECHA FACTURA INFORMATIVA',
  'FECHA ESTIMADA LIQUIDACIÓN',
  'DESTINO',
];

export const handleExcelFlInventory = (dataRaw, userInfo) => {
  const date = moment().format(noTimeZoneShortISODate);
  const data = [...dataRaw];
  const removedElements = dataToExport(data, userInfo);
  const ws = XLSX.utils.book_new();
  XLSX.utils.sheet_add_aoa(ws, [headerFlInventoryData]);
  XLSX.utils.sheet_add_json(ws, removedElements, {
    'origin': 'A2',
    'skipHeader': true,
  });
  const wb = {'Sheets': {'data': ws}, 'SheetNames': ['data']};
  const excelBuffer = XLSX.write(wb, {
    'type': 'array',
    'cellStyles': true,
  });
  const finalData = new Blob([excelBuffer], {'type': 'xlsx'});
  FileSaver.saveAs(finalData, `TEMS-Inventario-Flotante-${date}.xlsx`);
};

export const completeWithCeros = (value, digits) => {
  const passportLength = value?.length;
  if (passportLength >= digits) {
    return value;
  }
  return (('0'.repeat(digits - passportLength)) + value).toUpperCase();
};


const generateExcelValue = (key, value, row, {isUserTde, dealerId}) => {
  if (key === 'billingDate') {
    if (row.floatingStateText === 'FACTURADO') {
      return value ? value.substring(0, 10) : value;
    }
    return '';
  }
  if (key.includes('Date')) {
    return value ? value.substring(0, 10) : value;
  }
  if (key === 'daysInDeposit') {
    return value ? value.split('/')[0] : value;
  }
  if (key === 'reserveAdvance') {
    return row.reserveAdvanceText;
  }
  if (key === 'document') {
    return (isUserTde || row.dealer === String(TOYOTA_RUC) || dealerId === row.dealer) ?
      `${row.document || row.finalClient || ''}` :
      '';
  }
  if (key === 'clientName') {
    return (isUserTde || row.dealer === String(TOYOTA_RUC) || dealerId === row.dealer) ?
      (row.lastNames ? `${row.lastNames || ''} ${row.names || ''}` :
        `${row.finalClientName || ''}`) :
      '';
  }
  if (key === 'exonerationPerc') {
    return (isUserTde || row.dealer === String(TOYOTA_RUC) || dealerId === row.dealer) ?
      `${row.exonerationPerc}` :
      '';
  }
  return value;
};

const formatData = (data, titles, userInfo) => {
  return data.map(((row) => {
    const newRow = {};
    titles.map((key) => {
      newRow[key] = generateExcelValue(key, row[key], row, userInfo);
    });
    return newRow;
  }));
};


const generateTitles = (titles) => {
  const titleArray = titles.map((item) => {
    return item.headerText;
  });
  const titleItems = titles.map((item) => {
    return item.accessor;
  });
  return {titleArray, titleItems};
};

export const handleExcelFloatingReport = (dataRaw, titlesRaw, userInfo) => {
  const date = moment().format(noTimeZoneShortISODate);
  const {'titleArray': titles, titleItems} = generateTitles(titlesRaw);
  const data = formatData(dataRaw, titleItems, userInfo);
  const ws = XLSX.utils.book_new();
  XLSX.utils.sheet_add_aoa(ws, [titles]);

  XLSX.utils.sheet_add_json(ws, data, {
    'origin': 'A2',
    'skipHeader': true,
  });

  const wb = {'Sheets': {'data': ws}, 'SheetNames': ['data']};
  const excelBuffer = XLSX.write(wb, {
    'type': 'array',
    'cellStyles': true,
  });
  const finalData = new Blob([excelBuffer], {'type': 'xlsx'});
  FileSaver.saveAs(finalData, `TEMS-Reporte-Inventario-Flotante-${date}.xlsx`);
};

export const updateSelections = (checkValue, checkText, values, setValues) => {
  const options = [];
  const updatedCheck = values.map((val) => {
    if (checkText === val.text) {
      return ({'shortText': val.shortText, 'text': val.text, 'check': checkValue});
    }
    return val;
  });

  updatedCheck.forEach((val) => {
    if (val.check) {
      options.push(val.text);
    }
  });
  setValues(updatedCheck);
  return options;
};

export const setInitialCheckValues = (filterValues = [], options) => {
  return options.map((val) => {
    if (filterValues.includes(val.text)) {
      return ({'shortText': val.shortText, 'text': val.text, 'check': true});
    }
    return val;
  });
};

const listChasis = (data) => {
  if (Array.isArray(data)) {
    return data.map((line, index) => line.chassis);
  }
  return [data?.chassis];
};

export const generateJson = (data, key, previousValue, newValue, filters) => {
  return {
    'order_number': data?.orderNumber || null,
    'line': data?.line || null,
    'chassis': listChasis(data),
    'previous_value': previousValue,
    'new_value': newValue,
    'field': key,
    'filters': {...filters},
  };
};

export const jsonToParams = (json) => {
  return Object.keys(json).map((key) => {
    return `${encodeURIComponent(key)}=${encodeURIComponent(json[key])}`;
  }).join('&');
};
